import type { GenerationRatio } from "../../../../../types.ts";

export const aspectRatioToDimensions: Record<
  GenerationRatio,
  { width: number; height: number }
> = {
  r_1_1: { width: 1024, height: 1024 },
  r_4_3: { width: 1152, height: 896 },
  r_16_9: { width: 1344, height: 768 },
  r_3_4: { width: 896, height: 1152 },
  r_9_16: { width: 768, height: 1344 },
  r_191_100: { width: 1024, height: 536 },
  r_4_5: { width: 1024, height: 1280 },
};
